import {
    Paper,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Modal,
} from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { GetTimelines } from "../../store/actions/TimelineActions";
import styles from "./CreatedVideo.module.css";
import { TimelineInfo } from "../../models/Timeline";
import UpLoadTimelineModal from "../updateTimeline/UpLoadTimelineModal";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { PlayCircleFilled } from "@material-ui/icons";

function CreatedVideo() {
    const dispatch = useDispatch();
    // タイムラインをcineonhubにアップロード
    const [isOpenUploadTimelineModal, ShowUploadTimelineModal] = useState(false);
    const [isEditUploadTimelineProp, setIsEditUploadTimelineProp] = useState(false);
    const [isOpenLeaveDialogProp, setIsOpenLeaveDialogProp] = useState(false);
    // storeから値取得
    const { timelineList } = useSelector((state: AppState) => ({
        timelineList: state.timeline.timelineInfoList,
    }));
    // タイムラインが書き出された時のデータ
    const [timelineInfo, setTimelineInfo] = useState<TimelineInfo>({
        title: "",
        id: 0,
        name: "",
        created: "",
        updated: "",
        status: "",
        fileUrl: "",
        exportSettings: {
            bitrate: 0,
            denoise: false,
            edTemplateId: 0,
            framerate: 0,
            height: 0,
            opTemplateId: 0,
            width: 0,
        },
    });

    // 書き出し動画プレビュー
    const [fileUrl, SetFileUrl] = useState("");

    // 書き出し動画クリックでプレビューモーダル表示
    const handleClickVideo = (videoFileUrl: React.SetStateAction<string>) => {
        ShowPreviewModal(true);
        SetFileUrl(videoFileUrl);
    };

    const [visiblePreviewModal, ShowPreviewModal] = useInitFlag(false);

    const handleClosePreviewModal = () => {
        ShowPreviewModal(false);
    };

    // タイムラインアップロードモーダルを表示
    const OpenUploadTimelineModal = (timeline: TimelineInfo) => {
        setTimelineInfo(timeline);
        ShowUploadTimelineModal(true);
    };

    // タイムラインアップロードモーダルを非表示
    const CloseUploadTimelineModal = (isCloseFromOpenLeaveDialog: boolean) => {
        if (typeof isCloseFromOpenLeaveDialog !== "boolean" && isEditUploadTimelineProp) {
            setIsOpenLeaveDialogProp(true);
            return false;
        }

        setIsOpenLeaveDialogProp(false);
        ShowUploadTimelineModal(false);
    };

    useEffect(() => {
        // タイムライン取得
        dispatch(GetTimelines(["CREATING", "CREATED"]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.root}>
            <div className={styles.column}>
                {/* 書き出し済みタイムラインタイトル */}
                <h1 className={styles.columnHeader}>ライブラリ</h1>

                {/* 書き出し済みタイムライン一覧表示 */}
                {timelineList && (
                    <>
                        <TableContainer className={styles.table} component={Paper}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow style={{ width: "100%" }}>
                                        <TableCell align="left">
                                            <h2>id</h2>
                                        </TableCell>
                                        <TableCell align="left">
                                            <h2>タイトル</h2>
                                        </TableCell>
                                        <TableCell align="left">
                                            <h2>アップロード</h2>
                                        </TableCell>
                                        <TableCell align="left">
                                            <h2>ステータス</h2>
                                        </TableCell>
                                        {/* <TableCell align="left">
                                            <h2>ダウンロード</h2>
                                        </TableCell> */}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {timelineList.map((item, index) => (
                                        <TableRow key={index} style={{ width: "100%" }}>
                                            <TableCell>
                                                <div>{item.id}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={styles.cell}>
                                                    <div
                                                        className={styles.playIcon}
                                                        onClick={() => {
                                                            handleClickVideo(item.fileUrl);
                                                        }}
                                                    >
                                                        <PlayCircleFilled />
                                                    </div>
                                                    <div
                                                        onClick={() => {
                                                            handleClickVideo(item.fileUrl);
                                                        }}
                                                    >
                                                        {item.title}
                                                    </div>
                                                </div>
                                            </TableCell>

                                            <TableCell>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    type="submit"
                                                    onClick={() => {
                                                        OpenUploadTimelineModal(item);
                                                    }}
                                                >
                                                    アップロード
                                                </Button>
                                            </TableCell>
                                            <TableCell>
                                                <div className={styles.stausCell}>
                                                    {item.status}
                                                </div>
                                            </TableCell>
                                            {/* <TableCell>
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        type="submit"
                                                    >
                                                        <a href={item.fileUrl}>
                                                            ダウンロード
                                                        </a>
                                                    </Button>
                                                </TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/* 書き出し動画プレビュー再生モーダル */}
                        <Modal
                            open={visiblePreviewModal}
                            onClose={handleClosePreviewModal}
                            className={styles.previewModal}
                        >
                            <div className={styles.previewModalVideo}>
                                <video
                                    autoPlay
                                    controls
                                    src={fileUrl}
                                    controlsList="nofullscreen nodownload"
                                    disablePictureInPicture
                                ></video>
                            </div>
                        </Modal>
                        <Modal
                            open={isOpenUploadTimelineModal}
                            onClose={CloseUploadTimelineModal}
                            className={styles.uploadTimelineModal}
                        >
                            <>
                                <UpLoadTimelineModal
                                    isOpenLeaveDialogProp={isOpenLeaveDialogProp}
                                    setIsEditUploadTimelineProp={setIsEditUploadTimelineProp}
                                    setIsOpenLeaveDialogProp={setIsOpenLeaveDialogProp}
                                    timelineInfo={timelineInfo}
                                    closeUploadTimelineModal={CloseUploadTimelineModal}
                                    ShowUploadTimelineModal={ShowUploadTimelineModal}
                                />
                            </>
                        </Modal>
                    </>
                )}
            </div>
        </div>
    );
}
export default memo(CreatedVideo);
